import { Inject } from '@odinjs/odin';

import TokenConstants from '@philips-emr/hpms-health-insurance-commons/lib/constants/token-constants';
import { catchRenderException, shouldRenderMobile } from '@philips-emr/hpms-health-insurance-components';
import { AvatarAPI } from '@philips-emr/tws-components';
import { ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { AuthenticationService, ThemeService } from '@philips-emr/tws-core/lib/services';
import { applicationContext, foundationContext } from '@philips-emr/tws-foundation';

import { FragmentNames, HealthInsuranceAliases, RootRoutes } from '../codegen';
import { APPLICATION_ROUTES } from '../route';
import TermsService from '../services/terms-service';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.HEALTH_INSURANCE })
export default class HealthInsuranceController extends BaseController {

  @Inject(HealthInsuranceAliases.AVATAR_USER)
  private avatarUserAPI: AvatarAPI;

  @OnMount(HealthInsuranceAliases.AVATAR_USER)
  onMountAvatar(): void {
    const user = foundationContext.getUser();
    if (user && !shouldRenderMobile()) {
      let username = user.name;

      if (username.length > 30) {
        username = username.substring(0, 30);
        username = `${username}${'...'}`;
      }

      catchRenderException(() => {
        this.avatarUserAPI.setTitle(username);
      });
    }
  }

  @OnMount(HealthInsuranceAliases.LAYOUT_HI)
  onMountLayout(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
    TermsService.checkTerms();

    const token = AuthenticationService.getJWTToken();
    const nrSeqUser = token ? token.claims[TokenConstants.NR_SEQ_USER] as string : '';
    this.context.set({ nrSeqUser });
  }

  @OnClick(HealthInsuranceAliases.OPTION_MY_DATA)
  onClickMeusDados(): void {
    this.historyService.push(APPLICATION_ROUTES.MY_DATA);
  }

  @OnClick(HealthInsuranceAliases.OPTION_EXIT)
  onExitClick(): void {
    void AuthenticationService.logout();
    applicationContext.redirect(RootRoutes.LOGIN_ROUTE);
  }

}
